<template>
    <el-form :model="form" ref="form" label-width="100px" :inline-message=true>
        <el-form-item label="排课ID："  style="margin-left:10px" class="limit-configure" >
            <el-col :span="4" v-if="schoolId">
              {{schoolId}}
            </el-col>
        </el-form-item>
        <el-form-item label="排课查询密码"  style="margin-left:35px" class="limit-configure">
            <el-input   v-model.number="form.queryCode" :size="input_size" @change="queryCode" ></el-input>
        </el-form-item>
        <el-form-item label="备注：" label-width="100px" class="limit-configure">
            <el-input style="width: 300px;" type="textarea" v-model="form.memo" :size="input_size"
                      @input="emit"></el-input>
        </el-form-item>
    </el-form>
</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }
</style>

<script>
import CommonService from "~/services/common";
import params from "~/config/params";
export default {
    //props:[schoolId],
    data() {
        return {
            input_size:'mini',
            subjects:[],
            form: {
                queryCode:'',
                memo:''
            },
            configUsed:false,
            formLabelWidth:'120px',
        };
    },
    created() {

        CommonService.getQueryCode({
            customer_id: this.$route.query['id'],
            product_id :  params.PAIKE_NEW_PRODUCT_CODE
        }).then(res => {
            if(res.data['query_code'] != '') {
                this.form.memo =res.data['memo']
                this.form.queryCode =res.data['query_code']

            }
        })

    },
    props:{
            hidden:{
                required:false
            },
            schoolId: {
                required:false
            }
    },
    methods:{

        queryCode(){
            this.$emit('queryCode',this.form);
        },
        emit() {
            this.$emit('queryCode', this.form);
        },

        getQueryCode() {
            return this.form.queryCode;
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/views/order/paike/limitConfigure.vue